import { z } from 'zod';

export const portalSchema = z
  .object({
    VITE_PORTAL_URL: z.url(),
  })
  .transform((env) => ({
    portal: {
      url: env.VITE_PORTAL_URL,
    },
  }));
